/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_Load_FailedInputs */

const vi_error_page_load_failed = /** @type {(inputs: Error_Page_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải trang này.`)
};

/**

* @param {Error_Page_Load_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_page_load_failed = /** @type {((inputs?: Error_Page_Load_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_Load_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_page_load_failed(inputs)
});